
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure/policies/user-agreement",
      function () {
        return require("private-next-pages/conjure/policies/user-agreement.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure/policies/user-agreement"])
      });
    }
  